import { makeStyles } from '../../../../../styles';
export const useStyles = makeStyles((theme) => ({
    root: {
        minHeight: theme.spacing(3),
        padding: `${theme.spacing(2)} ${theme.spacing(7)}`,
    },
    typography: {
        fontSize: 24,
        fontWeight: 600,
        color: theme.colors.text[900],
    },
}));
//# sourceMappingURL=DialogTitle.styles.js.map